var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pb-4",
      class: {
        "emd-panel eu-no-padding": !_vm.label,
        "emd-panel__section": _vm.label,
      },
    },
    [
      _vm.label
        ? _c("div", { staticClass: "emd-panel__block" }, [
            _c("div", { staticClass: "el-chunk" }, [
              _c(
                "h2",
                { staticClass: "emd-text _color_default _type_caption" },
                [_vm._v(_vm._s(_vm.$t(_vm.label)))]
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { class: { "emd-panel__block": _vm.label } },
        [
          _c("JadeInputField", {
            attrs: {
              size: "medium",
              type: _vm.inputType,
              label: _vm.$t("users.edit.password"),
              placeholder: _vm.$attrs.placeholder,
              value: _vm.value,
              error: _vm.hasError,
              supportText: _vm.hasError ? _vm.$t("general.password-error") : "",
              trailingItem: _vm.trailingItem,
              autocomplete: "current-password",
            },
            on: {
              onTrailingItemClick: _vm.handleTrailingItemClick,
              input: _vm.onInput,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }